export const comboApiCollection = "https://10.111.201.120/mao/lov";

export const baseurl = "https://jsrdaapp.jsbl.com/rdaserviceswrapper/rda";
export const OTPBaseurl = "https://jsrdaapp.jsbl.com/dsbInternalOtp";


// export const comboApiCollection = baseurl + "/mao/lov";

export const rdaUserAuthenticationAPI =
  // baseurl + "/rdaips/RePatriation/rdainfo";
  baseurl + "/rdainfoservice";
  // baseurl + "/RdaRepatriationMid/test";

// export const rdaUserAuthenticationAPI ="http://10.121.214.84:8090/RePatriation/rdainfo";
// "https://rdaapp.jsbl.com/rdaips/rda-pension/rdainfo";
// "https://10.111.201.120:8081/rdaips/rda-pension/rdainfo";
// "https://10.111.201.120/rdaips/RePatriation/rdainfo";
// "https://10.111.201.120/rdaips/RePatriation/rdainfo";
// "http://10.121.214.84:8090/rdaips/RePatriation/rdainfo";
// "http://10.121.214.84:8090/RePatriation/rdainfo";

// export const otpGenerateAPI = OTPBaseurl + "/otp/v1/otp/generate-otp/";
export const otpGenerateAPI = OTPBaseurl + "/OtpInternalMid";
//  "http://10.121.214.84:8086/v1/otp/generate-otp/";
// "https://10.121.214.84:8086/v1/otp/generate-otp";
// "https://10.111.201.120/otp/v1/otp/generate-otp/";
// "http://10.121.214.142:8086/v1/otp/generate-otp/";
// "https://jsbank.mv.ermispk.com/api/Registration/GenerateGeneral_OTP_v1"
//   "https://jsmbphoenix.jsbl.com:2053/api/Registration/GenerateGeneral_OTP_v1";

// export const otpAuthenticateAPI = OTPBaseurl + "/otp/v1/otp/verify-otp";
export const otpAuthenticateAPI = OTPBaseurl + "/OtpInternalMid/verify";
// "http://10.121.214.84:8086/v1/otp/verify-otp";
// "https://10.111.201.120/otp/v1/otp/verify-otp";
// "http://10.121.214.142:8086/v1/otp/verify-otp";
// "https://jsbank.mv.ermispk.com/api/Registration/GeneralOTP_Verification_v1";
//   "https://jsmbphoenix.jsbl.com:2053/api/Registration/GeneralOTP_Verification_v1";

export const FinalDataApi =
  // "https://10.111.201.120/rdaips/ApniCar"; // Moosa Bhai Case
  // "https://10.111.201.120:8081/rdaips/rda-pension/create" // Moosa Bhai Case
  //"http://10.121.214.23:8082/rda-pension/create"; //Moosa Bhai case 2 API
  // "http://10.121.214.84:8090/ApniCar"
  baseurl + "/rdaapnicarmid";

//City
export const lovsApi = [
  "City",
  "Pricing_option",
  "Financing_option",
  "Insurance_company",
  "Vehicle_Make",
  "Financing_Tenure",
  "Insurance_company",
  "Relationship",
  "Percentage",
];

export const comboApiParam = {
  channel: "101",
  lovs_type: "City",
  module_id: "21",
};

export const comboApiParamPricing = {
  channel: "101",
  lovs_type: "Pricing_option",
  module_id: "21",
};

export const FinancingOptionCombo = {
  channel: "101",
  lovs_type: "Financing_option",
  module_id: "21",
};

export const InsuranceCompanyCombo = {
  channel: "101",
  lovs_type: "Insurance_company",
  module_id: "21",
};

export const vehicle_makeCombo = {
  channel: "101",
  lovs_type: "Vehicle_Make",
  module_id: "21",
};

export const FinancingTenureCombo = {
  channel: "101",
  lovs_type: "Financing_Tenure",
  module_id: "21",
};
